module.exports = __webpack_public_path__ + "img/Notisphere_Logo_Color_Dark_PAR.d7569039.png";